import request from "superagent";
import { uniqBy } from 'lodash';
// const remoteAPI = 'https://comments.ilfattoquotidiano.it/?ifq-user-api=load-data';
const storageKey = "ifq-custom-comments";

const callRemoteAPI = (
   method,
   url,
   data,
   callback,
   handleErrors,
   sentryContext,
   tmout = 15000
) => {
   const context = data ? data : sentryContext;
   // TODO :: add cookies to context errors

   const req = request(method, url)
   .withCredentials()
   .set("Content-Type", "application/x-www-form-urlencoded")
   .timeout(tmout)
   .send(data)
   .end(function(err, res) {
      try {
         if(err){
            // catch network errors (es. timeout, 4xx or 5xx)
            let errorMsg;
            if (err.timeout) {
               errorMsg = "Il server ha impiegato troppo tempo a rispondere.";
            } 
            else if (err.response) {
               errorMsg = err.response.body;
            } 
            else {
               errorMsg = err;
            }
            logException(err, context); // sentry error report 
            if (handleErrors) handleErrors(errorMsg);
         }
         else {
            // catch API error
            if (res.body.errors && res.body.errors.length > 0) {
               const errorMsg = res.body.errors[0] ? res.body.errors[0] : "generic error";
               const errorData = res.body.data;
               logException(errorMsg, context); // sentry error report 
               if (handleErrors) handleErrors(errorMsg, errorData);
            } else {
               // everything seems alright
               if (res.body) {
                  callback(res);
               }
            }
         }
      } catch (e) {
         // catch other errors
         const errorMsg = e ? e : "generic error";
         logException(errorMsg, context); // sentry error report 
         if (handleErrors) handleErrors(errorMsg);
      }
   });
};
// ------------------------------------------------
const setStateFromLocalStorage = (component, remoteAPI) => {
   // first check if localstorage is present and parse it
   const localData = getLocalStorage(storageKey);
   const now = getTimestamp();
   // if we have localStorage, the user id is the same and local timestamp has not expired use localdata
   if (
      localData &&
      localData.userId === component.props.userId &&
      localData.timeStamp &&
      now - localData.timeStamp < component.props.localStorageExpire
   ) {
      console.log("UPDATING STATE FROM LOCALSTORAGE", localData);
      component.setState({
         userId: localData.userId,
         username: decodeURIComponent(component.props.username),
         userIsLoggedIn: true,
         preapproved: localData.preapproved,
         avatar: localData.avatar,
         avatar_type: localData.avatar_type,
         hasFBConnect: localData.hasFBConnect,
         moderator: localData.moderator,
         followed: localData.followed,
         blocked_commenters: localData.blocked_commenters,
         disqus_connect: localData.disqus_connect,
         disqus_connect_url: localData.disqus_connect_url,
         notifications_digest_mail: localData.notifications_digest_mail,
         notifications_follow_comments: localData.notifications_follow_comments,
         notifications_follow_posts: localData.notifications_follow_posts,
         notifications_follow_users:localData.notifications_follow_users,
         notifications_reply_mail:localData.notifications_reply_mail,
         orderBy:localData.orderBy
      });
   } else {
      if (component.props.username) {
         // get info from API if we have user ID
         callRemoteAPI("get", remoteAPI, null, resp => {
            if (!resp.body.data.user_id) return; // don't get user state if user is not defined
            console.log("UPDATING STATE FROM REMOTE API");
            const updatedState = {
               userId: resp.body.data.user_id,
               username: decodeURIComponent(component.props.username),
               userIsLoggedIn: true,
               preapproved : resp.body.data.preapproved,
               avatar: resp.body.data.user_avatar,
               avatar_type: resp.body.data.user_avatar_type,
               hasFBConnect: resp.body.data.facebook_connect,
               moderator: resp.body.data.moderator,
               followed: resp.body.data.followed,
               blocked_commenters: resp.body.data.blocked_commenters,
               disqus_connect: resp.body.data.disqus_connect,
               disqus_connect_url: resp.body.data.disqus_connect_url,
               notifications_digest_mail: resp.body.data.notifications_settings.notifications_digest_mail,
               notifications_follow_comments: resp.body.data.notifications_settings.notifications_follow_comments,
               notifications_follow_posts: resp.body.data.notifications_settings.notifications_follow_posts,
               notifications_follow_users:resp.body.data.notifications_settings.notifications_follow_users,
               notifications_reply_mail:resp.body.data.notifications_settings.notifications_reply_mail
            };
            component.setState(updatedState, function() {
               updateLocalStorage(updatedState);
            });
         },
         err => {
            console.log(err);
         },
         localData
         );
      }
   }
};
// ------------------------------------------------
function updateLocalStorage(data, sync=true) {
   // merge a new object with object in localstorage
   let tmpStorage = getLocalStorage(storageKey);
   tmpStorage.timeStamp = getTimestamp();
   const updatedStorage = Object.assign(tmpStorage, data);
   localStorage.setItem(storageKey, JSON.stringify(updatedStorage));
   console.log("updating localstorage :::::::::::::::");
   // fire global custom event to sync different components in page (ie. notifications badge)
   // event is defined in template-tags.php
   if(sync) window.dispatchEvent(updateNotificationsBadge);
}
// ------------------------------------------------
function getLocalStorage() {
   const ret = JSON.parse(localStorage.getItem(storageKey)) || {};
   return ret;
}
// ------------------------------------------------
function getTimestamp() {
   return Math.floor(Date.now() / 1000); //set date in seconds to have the same php time unit
}
// ------------------------------------------------
function isExpired(timestamp, lifespan) {
   // check if comment is expired - lifespan defined in template-tags.php
   const now = Date.now();
   return (now-timestamp > lifespan) ? true : false;
}
// ------------------------------------------------
function logException(ex, context) {
   // google analytics -> ga('send', 'event', 'comments', 'error', ex);
   // Raven.captureException(ex, {
   //    extra: context
   // });
   window.console && console.error && console.error(ex);
}
// ------------------------------------------------
function decodeEntities(html) {
   var txt = document.createElement("textarea");
   txt.innerHTML = html;
   return txt.value;
}
// ------------------------------------------------
function forceUserLogout(errorMsg){
   // server reply with a user not logged in error
   // so force user logout to display the correct UI
   this.setState({userId:0, username:null, apiErrorMsg: errorMsg});
   // scroll top to show error message
   document.querySelector('#cComments').scrollIntoView({ behavior: 'smooth' });
   // and delete cookies via global function
   // defined in inc/template-tags.php
   window.forceLogout();
}
function returnUnique(arr){
   return _.uniqBy(arr, 'id');
}
// ------------------------------------------------
function flattenCommentsIds(arr){
	// convert array of comment object and children in a flattened array of ids
   return arr.reduce((outputArr, comment)=>{
      let children=[];
      if(comment.children.length>0){
         children = flattenCommentsIds(comment.children);
      }
      outputArr.push(...[comment.id, ...children]);
      return outputArr
   },[])
}
// ------------------------------------------------
function getColorFromString(str) {
   var hash = 0;
   if (str.length == 0) return hash;
   for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash; // Convert to 32bit integer
   }
   var hue = hash % 360;
   // return a pastel color
   return "hsl(" + hue + ",40%,85%)";
}

export {
   callRemoteAPI,
   setStateFromLocalStorage,
   updateLocalStorage,
   getLocalStorage,
   getTimestamp,
   isExpired,
   decodeEntities,
   forceUserLogout,
   returnUnique,
   flattenCommentsIds,
   getColorFromString
};



// WEBPACK FOOTER //
// ./components/utils/utils.js